import { Sparkles, Check } from 'lucide-react'
import { Link } from 'react-router-dom'
import Modal from './Modal'

interface UpgradeModalProps {
  isOpen: boolean
  onClose: () => void
  feature?: string
}

export default function UpgradeModal({
  isOpen,
  onClose,
  feature = 'detailed insights and recommendations'
}: UpgradeModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <Modal.Header onClose={onClose}>
        <Sparkles className="h-6 w-6 text-indigo-600" />
        <h2 className="text-xl font-semibold text-gray-900">Upgrade to Premium</h2>
      </Modal.Header>
      <Modal.Body>
        <p className="text-gray-700 mb-6">
          Unlock {feature} with a premium subscription.
        </p>

        <div className="space-y-3 mb-6">
          <div className="flex items-start gap-3">
            <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">Full Strategic Insights</p>
              <p className="text-sm text-gray-600">Deep competitive analysis and positioning recommendations</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">Tactical Action Plans</p>
              <p className="text-sm text-gray-600">Step-by-step guidance with specific tools and platforms</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">Unlimited Recommendations</p>
              <p className="text-sm text-gray-600">Access all AI-powered insights across all categories</p>
            </div>
          </div>
        </div>

        <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4">
          <p className="text-sm text-indigo-900 font-medium mb-1">Early Adopter Pricing</p>
          <p className="text-sm text-indigo-700">Get lifetime access at launch pricing before rates increase</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex gap-3">
        <button
          onClick={onClose}
          className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors font-medium"
        >
          Maybe Later
        </button>
        <Link
          to="/settings?tab=subscription"
          className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium text-center"
          onClick={onClose}
        >
          Upgrade Now
        </Link>
      </Modal.Footer>
    </Modal>
  )
}
